module.exports = __webpack_public_path__ + "media/images/new_landing/articles/learn-3-71d726d51066ca14f8ccb10ec28e09e2.jpg";